import { app } from "@microsoft/teams-js";
import { SubscriptionActivityDTO, SubscriptionDTO, SubscriptionUserDTO } from "@teams/types/api";

import { FetchResult, encodeApiUrl, fetchApiWithContext, isSuccess } from "./ChannelApi";

export const subscriptionApi = {
  getSubscription: async (
    context: app.Context,
    subscriptionId: string
  ): Promise<FetchResult<SubscriptionDTO> | undefined> => {
    const subscription = await fetchApiWithContext<SubscriptionDTO>(
      context,
      encodeApiUrl`/v1/subscription/${subscriptionId}`
    );

    if (isSuccess(subscription)) {
      deserializeSubscriptionDTO(subscription);
    }

    return subscription;
  },

  addOwner: async (
    context: app.Context,
    subscriptionId: string,
    user: SubscriptionUserDTO
  ): Promise<FetchResult<void>> => {
    const update = await fetchApiWithContext<SubscriptionDTO>(
      context,
      encodeApiUrl`/v1/subscription/${subscriptionId}/owner`,
      { method: "post", body: JSON.stringify(user) }
    );

    if (isSuccess(update)) {
      return;
    }

    return update;
  },

  removeOwner: async (
    context: app.Context,
    subscriptionId: string,
    userAADId: string
  ): Promise<FetchResult<void>> => {
    const update = await fetchApiWithContext<SubscriptionDTO>(
      context,
      encodeApiUrl`/v1/subscription/${subscriptionId}/owner/${userAADId}`,
      { method: "delete" }
    );

    if (isSuccess(update)) {
      return;
    }

    return update;
  },

  addUser: async (
    context: app.Context,
    subscriptionId: string,
    user: SubscriptionUserDTO
  ): Promise<FetchResult<void>> => {
    const update = await fetchApiWithContext<SubscriptionDTO>(
      context,
      encodeApiUrl`/v1/subscription/${subscriptionId}/user`,
      { method: "post", body: JSON.stringify(user) }
    );

    if (isSuccess(update)) {
      return;
    }

    return update;
  },

  removeUser: async (
    context: app.Context,
    subscriptionId: string,
    userAADId: string
  ): Promise<FetchResult<void>> => {
    const update = await fetchApiWithContext<SubscriptionDTO>(
      context,
      encodeApiUrl`/v1/subscription/${subscriptionId}/user/${userAADId}`,
      { method: "delete" }
    );

    if (isSuccess(update)) {
      return;
    }

    return update;
  },

  getActivityHistory: async (
    context: app.Context,
    subscriptionId: string
  ): Promise<FetchResult<SubscriptionActivityDTO>> => {
    const result = await fetchApiWithContext<SubscriptionActivityDTO>(
      context,
      encodeApiUrl`/v1/subscription/${subscriptionId}/activity`,
      { method: "get" }
    );

    if (isSuccess(result)) {
      result.periodStart = new Date(result.periodStart);
      result.periodEnd = new Date(result.periodEnd);
      return result;
    }

    return result;
  },
};

function deserializeSubscriptionDTO(subscription: SubscriptionDTO) {
  subscription.createdAt = new Date(subscription.createdAt);
  subscription.updatedAt = new Date(subscription.updatedAt);
}
